import axios from "axios";
import { message } from 'antd';

const url = process.env.REACT_APP_BACKEND_URL;

export async function getUser(auth,userId) {
    return axios({
        method: 'get',
        url: url + "/users/" + userId,
        headers: { Authorization: `Bearer ${auth}`},
    }).then(res => {
        return res.data;
    });
}

export async function agreeToTerms(authToken) {
    return axios({
        method: 'put',
        url: url + "/users/agreeToTerms",
        headers: { Authorization: `Bearer ${authToken}` },
    }).then(res => {
        return res.data;
    });
}


export async function followTeam(authToken, teamId) {
    return axios({
        method: 'put',
        url: url + "/users/followTeam",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { teamId: teamId }
    }).then(res => {
        return res.data;
    });
}


export async function updateLeaderInfo(authToken, numBetsWon, amountEthWon) {
    return axios({
        method: 'put',
        url: url + "/users/updateLeaderInfo",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { numBetsWon, amountEthWon }
    }).then(res => {
        return res.data;
    });
}

export async function unFollowTeam(authToken, teamId) {
    return axios({
        method: 'put',
        url: url + "/users/unFollowTeam",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { teamId: teamId }
    });
}

export async function followLeague(authToken, leagueId) {
    return axios({
        method: 'put',
        url: url + "/users/followLeague",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { leagueId: leagueId }
    }).then(res => {
        return res.data;
    });
}

export async function unFollowLeague(authToken, leagueId) {
    return axios({
        method: 'put',
        url: url + "/users/unFollowLeague",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { leagueId: leagueId }
    });
}

export async function followCategory(authToken, categoryId) {
    return axios({
        method: 'put',
        url: url + "/users/followCategory",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { categoryId: categoryId }
    }).then(res => {
        return res.data;
    });
}

export async function unFollowCategory(authToken, categoryId) {
    return axios({
        method: 'put',
        url: url + "/users/unFollowCategory",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { categoryId: categoryId }
    });
}

export async function findUsername(userId) {
    return axios({
        method: 'get',
        url: url + "/users/username/"+userId     

    }).then(res => {
        return res.data;
    });
}

export async function findAddress(userId) {
    return axios({
        method: 'get',
        url: url + "/users/address/"+userId     

    }).then(res => {
        return res.data;
    });
}


export async function checkFollowingTeam(authToken, teamId) {
    return axios({
        method: 'put',
        url: url + "/users/checkFollowingTeam",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { teamId: teamId }
    }).then(res => {
        return res;
    });
}

export async function checkFollowingLeague(authToken, leagueId) {
    return axios({
        method: 'put',
        url: url + "/users/checkFollowingLeague",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { leagueId: leagueId }
    }).then(res => {
        return res;
    });
}

export async function checkFollowingCategory(authToken, categoryId) {
    return axios({
        method: 'put',
        url: url + "/users/checkFollowingCategory",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { categoryId: categoryId }
    }).then(res => {
        return res;
    });
}



// WEBPACK FOOTER //
// ./src/api-calls/user.js